{
  "anySpecialist": {
    "text": "Show me the widest range of available appointment times.",
    "title": "I don’t mind who"
  },
  "nextLabel": "$t(common:next): <b>Choose a time<b>",
  "profile": "Specialist Profile",
  "specialists": {
    "00000000-0000-da7a-0003-000000000001": {
      "name": "Dr. Paul Casey",
      "profession": "Gastroenterologist, Endoscopist & Hepatologist",
      "profile": "<p>Dr Paul Casey is an experienced gastroenterologist who has been practising since 2005. He completed his medical training in Auckland and works publicly at Middlemore Hospital and privately at Ormiston. He performs gastroscopy and colonoscopy procedures and is known for his patient-centred approach to care.</p><p>He values clear communication, thorough planning, and helping patients feel informed and confident before any procedure.</p><p>Outside of work, Paul enjoys time on the golf course, running, and life with his wife, kids, and their two dogs.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000002": {
      "name": "Dr. Ravinder Ogra",
      "profession": "Gastroenterologist & Interventional Endoscopist",
      "profile": "<p>Dr. Ogra is a gastroenterologist specialising in gastroscopy, colonoscopy, and advanced interventional endoscopy - often avoiding the need for more invasive surgery. He trained in Kashmir, India, and completed his gastroenterology fellowship in New Zealand.</p><p>Known for his cheerful manner and warm communication style, Dr. Ogra puts patients at ease with a smile and light conversation, while always listening closely to their concerns.</p><p>Outside of medicine, he's a passionate gardener, a regular on New Zealand's Great Walks, and a devoted All Blacks supporter - having attended every Rugby World Cup since 2007.</p>",
      "titles": "MBBS, MD, FRACP, AGAF, FASGE"
    },
    "00000000-0000-da7a-0003-000000000003": {
      "name": "Dr. Stephen Persson",
      "profession": "Gastroenterologist, Endoscopist & Hepatologist",
      "profile": "<p>Dr. Stephen Persson is a specialist gastroenterologist with over 25 years of experience. He trained in Auckland and London, returning in 1998 to join Middlemore Hospital as a consultant. Stephen is known for his expertise in a wide range of gastrointestinal conditions and is a highly skilled endoscopist, participating in the NZ Bowel Cancer Screening Programme.</p><p>He combines clinical excellence with a warm, patient-focused approach and is committed to clear communication and continuity of care. Patients and referrers are welcome to contact him directly with any questions.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000004": {
      "name": "Dr. Robert Lopez",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000000005": {
      "name": "Dr. Dinesh Lal",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr. Lal is a senior gastroenterologist with over 25 years of specialist experience in gastroscopy, colonoscopy, and advanced procedures such as ERCP and EUS. He combines a meticulous, safety-focused approach with a strong emphasis on communication and patient reassurance.</p><p>Dinesh is passionate about preventative care, particularly in the early detection of bowel cancer.</p><p>Outside of work, he enjoys golf, walking his dog, and volunteering on medical missions to underserved communities - a pursuit he finds deeply rewarding both personally and professionally.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000006": {
      "name": "Dr. Parry Singh",
      "profession": "Colorectal Surgeon & Endoscopist.",
      "profile": "<p>Dr. Singh is a specialist colorectal surgeon with advanced training in surgical endoscopy.</p><p>His dual expertise in both surgery and endoscopy gives him a unique ability to diagnose and treat bowel and anorectal conditions such as haemorrhoids, fissures, fistulas, diverticulitis, and bowel cancer.</p><p>Known for his warm manner, clear communication, and touch of humour, Parry helps put patients at ease during what can be an anxious time.</p><p>Music is always playing - and requests are welcome - creating a calm, comfortable atmosphere where patients feel relaxed and in control.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000007": {
      "name": "Dr. Anurag Sekra",
      "profession": "Gastroenterologist & Interventional Endoscopist",
      "profile": "<p>Dr. Anurag Sekra is a gastroenterologist with a decade of specialist experience in gastroscopy, colonoscopy, and endoscopic ultrasound (EUS).</p><p>Known for his warm smile and clear communication, Anurag takes a patient-centred approach - carefully listening, explaining, and collaborating on treatment plans that feel right for each individual.</p><p>He brings a calm, thorough presence to every consultation, helping first-time patients feel at ease.</p><p>Outside of medicine, he enjoys travelling, cricket, running, and reading - all part of staying balanced and curious.<p>",
      "titles": "MBBS, FRACP"
    },
    "00000000-0000-da7a-0003-000000000008": {
      "name": "Dr. Stephen Gerred",
      "profession": "Gastroenterologist, Endoscopist & Hepatologist",
      "profile": "<p>Dr. Stephen Gerred is a highly experienced gastroenterologist with over 25 years of specialist practice.</p><p>Known for his calm, unhurried approach, Stephen takes time to listen, explain each step clearly, and ensure patients feel informed and at ease.</p><p>He understands how digestive health issues can affect day-to-day wellbeing and takes a holistic view of care.</p><p>Outside of work, Stephen enjoys tramping, skiing, travel, and raising a variety of animals on his rural South Auckland lifestyle block.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000009": {
      "name": "Dr. Jon Barnard",
      "profession": "Colorectal Surgeon & Endoscopist",
      "profile": "<p>Dr. Barnard is a specialist colorectal surgeon with a focus on bowel cancer detection and treatment, as well as common benign conditions such as haemorrhoids. He completed his medical training in Auckland and subspecialty colorectal training through CSSANZ.</p><p>Jon combines clinical excellence with a friendly, down-to-earth approach. He takes time to explain each procedure clearly, answer questions, and help patients feel at ease even inviting playlist requests.</p><p>Outside of work, Jon enjoys exploring the Waitäkere and Hunua Ranges with his wife and three children, making the most of New Zealand's great outdoors.</p>",
      "titles": "MBChB, FRACS"
    },
    "00000000-0000-da7a-0003-000000000010": {
      "name": "Dr. Sri Salvaratnam",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr. Selvaratnam is a gastroenterologist with expertise in diagnostic and therapeutic endoscopy. He trained in Auckland and Sydney, completing a fellowship in Inflammatory Bowel Disease, and has been practising for six years.</p><p>Known for his compassionate, patient-focused care, Dr. Selvaratnam ensures patients feel informed, respected, and comfortable throughout their journey.</p><p>Outside of work, Dr. Selvaratnam enjoys time with his wife and two young children. A passionate footballer, he represented New Zealand at the World Medical Football Championships in Dublin in 2025.</p>",
      "titles": "MBChB, MRES, FRACP"
    },
    "00000000-0000-da7a-0003-000000000011": {
      "name": "Dr. Aung Htoo",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000000012": {
      "name": "Dr. Laila Sheikh",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000000013": {
      "name": "Dr. Lily Wu",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000000014": {
      "name": "Dr. Maggie Chapman-Ow",
      "profession": "Gastroenterologist",
      "profile": "<p>Dr. Chapman-Ow is a gastroenterologist with expertise in diagnostic and therapeutic endoscopy, including polypectomy and dilatation. She trained in Auckland and the UK, holds a doctoral degree from the University of Auckland, and has been practising since 2014.</p><p>Warm, empathetic, and calm under pressure, Maggie takes time to ensure each patient feels safe, heard, and well cared for—especially those navigating complex or daily symptoms.</p><p>Outside of work, she enjoys mountain biking and beach adventures with her young son and family.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000000015": {
      "name": "Dr. Paras Garg",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000000016": {
      "name": "Dr. Mirthe van de Valk",
      "profession": "NEED SPECIALTIES",
      "profile": "<p>NEED BIO</p>",
      "titles": "NEED QUALS"
    },
    "00000000-0000-da7a-0003-000000001001": {
      "name": "Dr. Peter Cassidy",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Cassidy is a New Zealand-trained gastroenterologist known for his calm, attentive manner and clear communication style.</p><p>After completing his medical degree at the University of Otago, he trained in internal medicine and gastroenterology in Auckland. He has a particular interest in inflammatory bowel disease (IBD) and is actively involved in bowel cancer screening programmes.</p><p>Patients often comment on his reassuring presence and willingness to explain things clearly.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001002": {
      "name": "Dr. Rowan Osmani",
      "profession": "Gastroenterologist",
      "profile": "<p>Dr Osmani is a New Zealand-born gastroenterologist of Afghan heritage. She completed her PhD in coeliac disease at the University of Auckland and continues to be active in clinical research.</p><p>Patients appreciate her holistic approach, especially in the management of complex, functional gut conditions.</p><p>She’s passionate about empowering patients with knowledge and improving quality of life.</p>",
      "titles": "MBChB, FRACP, PhD"
    },
    "00000000-0000-da7a-0003-000000001003": {
      "name": "Dr. Sean Pearson",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Pearson is a general gastroenterologist with a focus on colorectal cancer prevention. He trained in Christchurch and completed further endoscopy training at the Royal Melbourne Hospital.</p><p>Known for his thoroughness and approachability, he works closely with GPs to ensure timely access to screening and surveillance.</p><p>In his spare time, he enjoys tramping and photography.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001004": {
      "name": "Dr. Rodrigo Lowe",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Lowe was born in Brazil and completed his medical degree in São Paulo before moving to New Zealand for advanced training.</p><p>His warm, friendly manner is matched by a strong interest in swallowing disorders and oesophageal health.</p><p>He is fluent in Portuguese and conversational in Spanish, and enjoys connecting with patients from all backgrounds.</p>",
      "titles": "MD, FRACP"
    },
    "00000000-0000-da7a-0003-000000001005": {
      "name": "Dr. Daniel Larkin",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Larkin is a New Zealand-born gastroenterologist with additional training in paediatrics, making him especially popular with younger adult patients.</p><p>He takes a down-to-earth, friendly approach and is a strong advocate for gut health education.</p><p>He completed his gastroenterology training in Auckland and now balances private and public work with raising two energetic children.</p>",
      "titles": "MBChB, FRACP, DipPaed"
    },
    "00000000-0000-da7a-0003-000000001006": {
      "name": "Dr. Pavan Sandhu",
      "profession": "Gastroenterologist",
      "profile": "<p>Dr Sandhu is a New Zealand-trained gastroenterologist of Punjabi descent. She is particularly interested in the intersection of hormonal changes and gastrointestinal symptoms in women.</p><p>Known for her empathetic manner and strong communication skills, she creates a safe, collaborative environment for her patients.</p><p>Outside of work, she enjoys cooking and long-distance running.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001007": {
      "name": "Dr. Arun Sethi",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Sethi trained in India and New Zealand, with a particular focus on liver health. He has extensive experience managing hepatitis, fatty liver, and metabolic syndrome-related complications.</p><p>Patients describe him as thoughtful and methodical, with a knack for helping them understand complex conditions.</p><p>He also contributes to community health initiatives promoting early detection of liver disease.</p>",
      "titles": "MBBS, MD, FRACP"
    },
    "00000000-0000-da7a-0003-000000001008": {
      "name": "Dr. Simon Garrett",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Originally from the UK, Dr Garrett trained at University College London and completed his advanced gastroenterology training in both London and Wellington.</p><p>With a subspecialty interest in therapeutic endoscopy, he brings both technical precision and a thoughtful, empathetic approach to patient care.</p><p>Outside the clinic, he’s a keen cyclist and amateur gardener.</p>",
      "titles": "MBChB, MRCP (UK), FRACP"
    },
    "00000000-0000-da7a-0003-000000001009": {
      "name": "Dr. John Barnwell",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Barnwell is a senior gastroenterologist with deep experience in advanced endoscopic procedures. He trained in New Zealand and completed a fellowship in endoscopic ultrasound in Brisbane.</p><p>Despite his technical expertise, patients often remark on how down-to-earth and approachable he is.</p><p>He brings a calm, confident energy to the team.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001010": {
      "name": "Dr. Suresh Selby",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Selby is a second-generation Kiwi-Indian endoscopist who is passionate about delivering high-quality, equitable care.</p><p>He has led quality improvement initiatives in both public and private settings, and is deeply committed to improving access to screening and early intervention.</p><p>When he’s not in the procedure room, you’ll likely find him paddleboarding or exploring coastal walks.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001011": {
      "name": "Dr. Lillian Wong",
      "profession": "Gastroenterologist & Endoscopist",
      "profile": "<p>Dr Wong is a Hong Kong–born New Zealander who brings a thoughtful, patient-centred approach to her work. She completed her medical training in Auckland and undertook additional experience in upper GI disorders in Sydney.</p><p>With her gentle manner and strong attention to detail, she’s particularly popular with patients undergoing their first endoscopy.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000000-0000-da7a-0003-000000001012": {
      "name": "Dr. Aaron Hales",
      "profession": "Gastroenterologist",
      "profile": "<p>Dr Hales has a strong interest in the role of the nervous system in gut function and dysfunction. His patients appreciate his listening skills and his interest in exploring both physical and psychological factors contributing to gut symptoms.</p><p>He trained in Dunedin and Auckland, and continues to teach and supervise trainees in the public system.</p>",
      "titles": "MBChB, FRACP"
    },
    "00000001-0000-da7a-0003-000000001001": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000002-0000-da7a-0003-000000001002": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000003-0000-da7a-0003-000000001003": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000004-0000-da7a-0003-000000001004": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000005-0000-da7a-0003-000000001005": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000006-0000-da7a-0003-000000001006": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000007-0000-da7a-0003-000000001007": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000008-0000-da7a-0003-000000001008": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "00000009-0000-da7a-0003-000000001009": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "0000000a-0000-da7a-0003-000000001010": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "0000000b-0000-da7a-0003-000000001011": {
      "name": "TODO",
      "profession": "TODO",
      "profile": "<p>TODO</p>",
      "titles": "TODO"
    },
    "unknown": {
      "name": "a Specialist",
      "profession": "Specialist",
      "profile": "<p></p>",
      "titles": ""
    }
  },
  "textMultiple": "<p>All of these specialists are great choices. Pick one, or just continue with “I don’t mind who”.</p>",
  "textSingle": "<p>Your {{requestingPractitioner.practitionerRole}} - {{requestingPractitioner.displayName}} - has referred you to:</p>",
  "titleMultiple": "Choose your specialist",
  "titleSingle": "Your specialist",
  "viewProfile": "View full profile"
}
